import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { FormGroup } from '@angular/forms';
import { TCampaniaEspecificaViewModel } from '../campaniaespecifica.types';
import { Tc } from 'src/app/components/core/_infrastructure/types/common';

@Component({
    selector: 'app-campaniaespecifica-edit',
    templateUrl: './campaniaespecifica-edit.component.html',
})
export class CampaniaEspecificaEditComponent extends ComponentBase implements OnChanges, OnInit {
    @Input() campaniaEspecifica: TCampaniaEspecificaViewModel;
    @Input() formGroup: FormGroup;
    @Input() paises: Tc[];
    @Input() modelosCf: Tc[];
    @Input() idiomas: Tc[];

    isCollapsedCabecera = false;
    isCollapsedPeriodos = false;
    isCollapsedTratamiento = false;
    isCollapsedDeclaraciones = false;

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.updateForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.campaniaEspecifica?.currentValue) {
            this.campaniaEspecifica = { ...changes.campaniaEspecifica.currentValue };
            this.updateForm();
        }
        if (changes?.paises?.currentValue) {
            this.formGroup.get('IdPais')?.enable();
        }
        if (changes?.modelosCf?.currentValue) {
            this.formGroup.get('IdModeloCf')?.enable();
        }
        if (changes?.idiomas?.currentValue) {
            this.formGroup.get('IdIdioma')?.enable();
        }
    }

    /**
     * This functions sets the values in the campaniaEspecifica (@Input) into the form.
     */
    private updateForm(): void {
        if (this.campaniaEspecifica) {
            this.formGroup.setValue({
                Descripcion: this.campaniaEspecifica?.Descripcion || '',
                Id: this.campaniaEspecifica?.Id || null, // Not visible but needed
                IdPais: this.campaniaEspecifica?.IdPais || null,
                IdModeloCf: this.campaniaEspecifica?.IdModeloCf || null,
                FechaCreacion: this.campaniaEspecifica?.FechaCreacion || null,
                IdIdioma: this.campaniaEspecifica?.IdIdioma || null,
            });
        }

        this.form = this.formGroup; // componentBase uses this.form
    }

    get title(): string {
        return this.campaniaEspecifica ? 'Editar' : 'Nueva'; // work mode: edition or creation
    }
}
